// @flow

export default class Schedule {
  day: number;
  weekDay: string;
  month: string;
  period: string;
  active: boolean;
  backendFormattedDate: string;
  backendFormattedTime: string;
  availableTimes: Array<number>;
  
  constructor(data: any = {}) {
    this.day = data.day;
    this.weekDay = data.weekDay;
    this.month = data.month;
    this.period = data.period;
    this.backendFormattedDate = data.backendFormattedDate;
    this.backendFormattedTime = data.backendFormattedTime;
    this.availableTimes = data.availableTimes;
    this.active = false;
  }
  
  readablePeriod = () => {
    return `${this.period[0]} - ${this.period[1]}`;
  };
}
